var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"loadcard",style:(("width:" + _vm.width + ";height:" + _vm.height + "; "))},[(!_vm.message)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"#E56D9B"}}):_c('p',[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f1b01b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Song/LoadCard.vue
// module id = null
// module chunks = 